import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function pingRequest() {
  return request({
    method: 'get',
    url: urls.ping,
    headers: getHeaders(),
  });
}

export async function dashboardDataRequest(data = {}) {
  return request({
    method: 'get',
    url: urls.roles,
    data,
    headers: getHeaders(),
  });
}

export async function projectsRequest() {
  return request({
    method: 'get',
    url: urls.projects,
    headers: getHeaders(),
  });
}

export async function rolesRequest() {
  return request({
    method: 'get',
    url: urls.roles,
    headers: getHeaders(),
  });
}

export async function modulesRequest() {
  return request({
    method: 'get',
    url: urls.modules,
    headers: getHeaders(),
  });
}

export async function currentUserDataRequest() {
  return request({
    method: 'get',
    url: urls.currentUserData,
    headers: getHeaders(),
  });
}

export async function forgotPasswordRequest(data) {
  return request({
    method: 'post',
    url: urls.forgotPassword,
    data,
    headers: getHeaders({ noAuth: true }),
  });
}

export async function tokenValidationRequest(data, tokenRequest) {
  const url = tokenRequest ? urls.tokenValidation : urls.passwordsRecoverer;
  return request({
    method: 'post',
    url,
    data,
    headers: getHeaders({ noAuth: true }),
  });
}



// WEBPACK FOOTER //
// ./src/services/app.js